import { ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';

export const childEntitiesReadOnly = (caseState, uiEngineProps) => {
  
  const descriptor: ComponentDescriptor = uiEngineProps.componentDescriptor;
  const childrenReadyOnly = descriptor.children?.every(child => child.properties.readOnly);
  
  return {
    childEntitiesReadOnly: childrenReadyOnly
  };
};
